module.exports = __webpack_public_path__ + "img/gb9115_25_d.prt.7e118ab4.jpg";